import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormControl} from "@angular/forms";
import {Subject} from "rxjs";
import {TextUtils} from "../../../../../shared/utils/text-utils";
import {ActivatedRoute} from "@angular/router";
import {DialogService} from "../../../../../../ng2-bootstrap-modal/dialog.service";
import {NavigationService} from "../navigation.service";
import {IMenuItem} from "../navigation.interface";
import {Config} from "../../../../../config/config";
import {Store} from "@ngrx/store";
import * as fromStore from "../../../../../store";
import {RemoveItemDialogComponent} from "../../products/remove-item-dialog/remove-item-dialog.component";
import {filter, takeUntil} from "rxjs/operators";
import {NotifierComponent} from "../../../../../shared/components/notifier/notifier.component";
import {Notification} from "../../../../../shared/components/notifier/notification";
import {NotificationType} from "../../../../../shared/components/notifier/notification-type";
import {DbModalService} from "../../../../../modules/modal/modal";


@Component({
    selector: 'db-navigation-menu',
    templateUrl: './navigation-menu.component.html',
    styleUrls: ['./navigation-menu.component.scss'],
    standalone: false
})
export class NavigationMenuComponent implements OnInit, OnDestroy {

  isMobile = false;
  searchTerm: FormControl = new FormControl();
  website = this._activatedRoute.snapshot.parent.parent.data['website'];
  isFakeMode = this.website.id === Config.demoDomainId;
  order: 'asc' | 'desc' = 'desc';
  menus: IMenuItem[] = [];
  currentPage = 1;
  loading = true;
  menuUrl: string = '';
  private _subscription$: Subject<void> = new Subject<void>();

  constructor(private _activatedRoute: ActivatedRoute,
              public navigationService: NavigationService,
              private _dialogService: DialogService,
              private _modalService: DbModalService,
              private _store: Store<fromStore.DbStoreState>
  ) {
  }

  ngOnInit() {
    this._dispatchMenus();
    this._getMenus();
    this.navigationService.sendAnalyticsEvent('Navigation pageview', this.website.id);
  }

  ngOnDestroy() {
    this._subscription$.next();
    this._subscription$.complete();
  }

  private _dispatchMenus(showLoading = true) {
    this.loading = showLoading;

    this._store.dispatch(new fromStore.LoadEcommerceMenuList({websiteId: this.website.id}));
  }

  private _getMenus() {
    this._store.select(fromStore.getMenus(this.website.id))
      .pipe(
        filter((menus) => !!menus),
        takeUntil(this._subscription$)
      )
      .subscribe((response) => {
        this.menus = response.map(value => {
          value.name = this.navigationService.decodeHtml(value.name);
          return value;
        });
        this.loading = false;
      });
  }

  onRemoveItem(id: number) {
    const alternativePopup = {
      title: "Delete this menu",
      description: "Are you sure you want to delete this menu?",
      button: "Delete"
    };
    const modal = this._modalService.open(RemoveItemDialogComponent);
    modal.componentInstance.alternativePopup = alternativePopup;
    modal.closed
      .subscribe(value => {
        if (value) {
          this._removeItem(id);
        }
      });
  }

  private _removeItem(id: number) {
    this.loading = true;
    this.navigationService.deleteMenu(this.website && this.website.id, id).subscribe((value) => {
        if (!value) {
          return;
        }
        if (value.success) {
          this._dispatchMenus();
          NotifierComponent.notify(new Notification(TextUtils.getText('text_menusUpdated'), NotificationType.SUCCESS));
        } else {
          NotifierComponent.notify(new Notification(TextUtils.getText('text_somethingWentWrong'), NotificationType.DANGER));
        }
      },
    );
  }

}
